// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
}

ion-col {
  display: flex;
}

.back-icon {
  font-size: 30px;
  cursor: pointer;
}

.align-question-title {
  width: 100%;
  text-align: center;
}

ion-item-divider {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 2px;
  padding-right: 2px;
}

ionic-calendar-date-picker {
  display: block;
  margin: 0 auto;
}

.ion-ios-star-outline {
  color: #252525;
}

ul {
  padding: 0px;
}
ul.rating li {
  padding: 5px 10px !important;
  background: none;
  color: #ffb400;
}
ul.rating li ion-icon {
  font-size: 30px;
}

.stars {
  color: #ffd600;
  font-size: 25px;
}

.bg-content {
  background: #eeeeee;
}

.survey-title {
  font-size: 1.2em;
}

.card-content {
  margin: 0 auto;
  width: 100%;
  position: relative;
  z-index: 9999;
}

ion-textarea {
  height: 90px;
  border: 1px solid #E1DDEC;
  --padding-start: 10px;
  width: 100%;
  border-radius: 10px;
}

.question-title-main {
  font-size: 1.3em;
  font-weight: 600;
  font-family: var(--font);
  font-weight: 400;
}

.question-title {
  font-family: var(--font);
  font-weight: 600;
  font-size: 20px;
  text-align: left;
  margin: 0 16px;
}

.option-size {
  font-size: 0.9em;
  opacity: 0.4;
}

.survey-title {
  position: relative;
  z-index: 1;
}

.questions-to-user {
  position: relative;
  z-index: 99999;
}

.evalution-align {
  width: 100%;
  display: flex;
  justify-content: center;
}

.btn-default {
  border-radius: 15px !important;
}

.spinner {
  margin: 0 auto;
  display: block;
}

.align-loader-custom {
  margin: 0 auto;
  margin-top: 0px;
  position: relative;
  top: 30px;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
}

ion-item-divider {
  margin-bottom: 5px !important;
}

.infobooth {
  background-color: #FFFFFF;
  padding: 10px 0 0 16px;
  font-family: var(--font);
  font-weight: 300;
}

.upload-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.photo-icon {
  font-size: 1.2em;
}

.pic-style {
  font-size: 1.6em;
  cursor: pointer;
}

.input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  cursor: pointer;
}

.document-type-question {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.document-type-question .question-document-img {
  max-width: 200px;
  margin-bottom: 15px;
}

.btn-validate {
  height: 56px;
  width: 90%;
  font-family: var(--font);
  font-weight: 700;
  font-size: 16px;
  text-transform: none;
  border-radius: 28px;
  margin: 0 auto 10px auto;
}

ion-toolbar {
  border-radius: 0;
}
ion-toolbar p {
  font-family: var(--font);
  font-weight: 700;
  font-size: 20px;
}

@media screen and (min-width: 768px) {
  ion-toolbar ion-title p {
    text-align: left;
  }
  .evaluation {
    width: 45%;
  }
  .evaluation-box {
    display: flex;
    align-items: center;
    margin-top: 0.4rem;
  }
  .evaluation-box > .question-title-infobooth {
    width: 70% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/survey/survey.page.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,eAAA;EACA,eAAA;AACJ;;AAGA;EACI,WAAA;EACA,kBAAA;AAAJ;;AAGA;EAEI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,cAAA;EACA,cAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,YAAA;AADJ;AAGI;EACI,4BAAA;EACA,gBAAA;EACA,cAAA;AADR;AAGQ;EACI,eAAA;AADZ;;AAMA;EACI,cAAA;EACA,eAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAHJ;;AAMA;EACI,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,gBAAA;EACA,wBAAA;EAA0B,gBAAA;AAF9B;;AAKA;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;;AAIA;EACI,gBAAA;EACA,YAAA;AADJ;;AAIA;EACI,kBAAA;EACA,UAAA;AADJ;;AAIA;EACI,kBAAA;EACA,cAAA;AADJ;;AAIA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AADJ;;AAIA;EACI,8BAAA;AADJ;;AAIA;EACI,cAAA;EACA,cAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;AADJ;;AAIA;EACI,6BAAA;AADJ;;AAIA;EACI,yBAAA;EACA,sBAAA;EACA,wBAAA;EAA0B,gBAAA;AAA9B;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEI;EACI,gBAAA;EACA,mBAAA;AAAR;;AAIA;EACI,YAAA;EACA,UAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;AACI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAER;;AAEA;EAGQ;IACI,gBAAA;EADV;EAIE;IACI,UAAA;EAFN;EAIE;IACI,aAAA;IACA,mBAAA;IACA,kBAAA;EAFN;EAIM;IACI,qBAAA;EAFV;AACF","sourcesContent":[":host {\n    width: 100%;\n    height: 100%;\n}\n\nion-col {\n    display: flex;\n}\n\n.back-icon {\n    font-size: 30px;\n    cursor: pointer;\n}\n\n\n.align-question-title {\n    width: 100%;\n    text-align: center;\n}\n\nion-item-divider {\n    // width: 100vw;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    padding-left: 2px;\n    padding-right: 2px;\n}\n\nionic-calendar-date-picker {\n    display: block;\n    margin: 0 auto;\n}\n\n.ion-ios-star-outline {\n    color: #252525;\n}\n\nul {\n    padding: 0px;\n\n    &.rating li {\n        padding: 5px 10px !important;\n        background: none;\n        color: #ffb400;\n\n        ion-icon {\n            font-size: 30px;\n        }\n    }\n}\n\n.stars {\n    color: #ffd600;\n    font-size: 25px;\n}\n\n.bg-content {\n    background: #eeeeee;\n}\n\n.survey-title {\n    font-size: 1.2em;\n}\n\n.card-content {\n    margin: 0 auto;\n    width: 100%;\n    position: relative;\n    z-index: 9999;\n}\n\nion-textarea {\n    height: 90px;\n    border: 1px solid #E1DDEC;\n    --padding-start: 10px;\n    width: 100%;\n    border-radius: 10px;\n}\n\n.question-title-main {\n    font-size: 1.3em;\n    font-weight: 600;\n    font-family: var(--font); font-weight: 400;;\n}\n\n.question-title {\n    font-family: var(--font); font-weight: 600;;\n    font-size: 20px;\n    text-align: left;\n    margin: 0 16px;\n}\n\n.option-size {\n    font-size: .9em;\n    opacity: .4;\n}\n\n.survey-title {\n    position: relative;\n    z-index: 1;\n}\n\n.questions-to-user {\n    position: relative;\n    z-index: 99999;\n}\n\n.evalution-align {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.btn-default {\n    border-radius: 15px !important;\n}\n\n.spinner {\n    margin: 0 auto;\n    display: block;\n}\n\n.align-loader-custom {\n    margin: 0 auto;\n    margin-top: 0px;\n    position: relative;\n    top: 30px;\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n}\n\nion-item-divider {\n    margin-bottom: 5px !important;\n}\n\n.infobooth {\n    background-color: #FFFFFF;\n    padding: 10px 0 0 16px;\n    font-family: var(--font); font-weight: 300;;\n}\n\n.upload-btn-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.photo-icon {\n    font-size: 1.2em;\n}\n\n.pic-style {\n    font-size: 1.6em;\n    cursor: pointer;\n}\n\n.input-file {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n    cursor: pointer;\n}\n\n.document-type-question {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .question-document-img {\n        max-width: 200px;\n        margin-bottom: 15px;\n    }\n}\n\n.btn-validate{\n    height: 56px;\n    width: 90% ;\n    font-family: var(--font); font-weight: 700;;\n    font-size: 16px;\n    text-transform: none;\n    border-radius: 28px;\n    margin: 0 auto 10px auto;\n}\n\nion-toolbar{\n    border-radius: 0;\n    p{\n        font-family: var(--font); font-weight: 700;;\n        font-size: 20px;\n    }\n}\n\n@media screen and (min-width: 768px) {\n    ion-toolbar{\n        // border-radius: 37px;\n        ion-title p{\n            text-align: left;\n        }\n    }\n    .evaluation{\n        width: 45%;\n    }\n    .evaluation-box{\n        display: flex;\n        align-items: center;\n        margin-top: 0.4rem;\n        // justify-content: space-between;\n        > .question-title-infobooth{\n            width: 70% !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
